module.exports = __webpack_public_path__ + "img/platinum.bf179382.png";